export const PAYROLLS_RESET_STATE = 'PAYROLLS_RESET_STATE';
export const PAYROLLS_CURRENT_ITEM = 'PAYROLLS_CURRENT_ITEM';

export const PAYROLLS_REQUEST_LOADING = 'PAYROLLS_REQUEST_LOADING';
export const PAYROLLS_REQUEST_SUCCESS = 'PAYROLLS_REQUEST_SUCCESS';
export const PAYROLLS_REQUEST_FAILED = 'PAYROLLS_REQUEST_FAILED';

export const PAYROLLS_CURRENT_ACTION = 'PAYROLLS_CURRENT_ACTION';
export const PAYROLLS_RESET_ACTION = 'PAYROLLS_RESET_ACTION';